import { SxStyleProp } from 'theme-ui';

const commonTextStyle = {
  color: 'grey4',
  fontWeight: 'normal'
};

export const labelStyle: SxStyleProp = {
  ...commonTextStyle,
  fontSize: '12px',
  color: 'grey7'
};
export const buttonTitleStyle: SxStyleProp = {
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 'normal',
  color: 'grey7',
  textAlign: 'center',
  textTransform: 'capitalize'
};

export const subscribeMessageStyle: SxStyleProp = {
  fontWeight: 'normal',
  fontSize: 12,
  ml: 3,
  color: 'black',
  flex: 1
};

export const linkStyle: SxStyleProp = {
  color: 'primary3',
  borderBottom: '1px solid',
  '&:hover': {
    borderBottom: '1px solid transparent'
  },
  cursor: 'pointer'
};
